import { MenuItem } from "../../../ui/components/atoms/menu/menu.types";
import { HelpTemplateItem } from "../components/help-center/help-center.models";

export const MENU_ITEMS: MenuItem[] = [
  {
    label: 'DASHBOARD',
    icon: 'home',
    link: '/home',
  },
  {
    label: 'DISTRIBUTION_NETWORK.NAME',
    link: '/distribution-network',
    icon: 'icons:line-close',
  },
  {
    label: 'LOSSES.LABEL',
    link: '/losses',
    icon: 'line-chart'
  },
  {
    label: 'EVENTS.LABEL',
    link: '/events',
    icon: 'notification'
  },
  {
    label: 'ALARMS.LABEL',
    icon: 'bell',
    link: '/alarms'
  },
  {
    label: 'DEVELOPER',
    icon: 'api',
    link: '/dev',
    isDev: true
  },
  {
    label: 'ADMIN.LABEL',
    link: '/administration',
    icon: 'control',
  },
]

export const MENU_BOTTOM_ITEMS: MenuItem[] = [
  // {
  //   label: 'ADMIN.LABEL',
  //   link: '/administration',
  //   icon: 'global',
  // },
  // {
  //   label: 'SETTINGS',
  //   link: '/settings',
  //   icon: 'setting',
  // },
  {
    label: 'MY_PROFILE',
    icon: 'user',
    items: [
      {
        label: 'SPANISH',
        icon: 'icons:spain',
        action: {
          type: 'SET_LANGUAGE',
          value: 'es'
        }
      },
      {
        label: 'ENGLISH',
        icon: 'icons:england',
        action: {
          type: 'SET_LANGUAGE',
          value: 'en'
        }
      },
      {
        label: 'LOGOUT',
        icon: 'logout',
        action: {
          type: 'LOGOUT'
        }
      }
    ]
  },
]

const MENU_HELP_URL_BASE = 'https://cide365.sharepoint.com/sites/Portal-de-Formacion/SitePages/';
export const MENU_HELP_CENTER_ITEMS: HelpTemplateItem[] = [
  {
    label: 'HELP_CENTER.SABT',
    icon: 'apartment',
    url: `${MENU_HELP_URL_BASE}/RETRIBUCION/Infraestructura.aspx`,
  },
];
